import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getMyFiles({ commit, state }) {
    commit(types.GET_MY_FILES_REQUEST);
    const params = { user: '', page: state.myFilesPage };
    colonyAPI.get('/filebox/', { params })
      .then(response => commit(types.GET_MY_FILES_SUCCESS, response))
      .catch(error => commit(types.GET_MY_FILES_FAILURE, error));
  },
  getCompanyFiles({ commit, state }) {
    commit(types.GET_COMPANY_FILES_REQUEST);
    const params = { page: state.companyFilesPage };
    colonyAPI.get('/filebox/', { params })
      .then(response => commit(types.GET_COMPANY_FILES_SUCCESS, response))
      .catch(error => commit(types.GET_COMPANY_FILES_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/filebox/actions.js